<template>
  <section class="content" id="apps">
    <div class="item" @click="$root.globalClick($event)">
      <div id="app" class="common-container item__img-wrap" style="overflow: hidden">
        <div class="item__img">
          <preloader></preloader>
          <Navber />
          <router-link to="/info_center"></router-link>
          <div>
            <transition name="fade" mode="out-in">
              <router-view></router-view>
            </transition>
          </div>
          <Footer />
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import Navber from "./view/navber.vue";
import Footer from "./view/footer.vue";

//import Home from "./components/home.vue"
import Preloader from "./components/Activity/preloader";
export default {
  name: "apps",

  components: {
    Navber: Navber,
    Footer: Footer,
    preloader: Preloader,
    //"home": Home
  },
};
</script>

<style scoped>
/* Page Loader */
@font-face {
  font-family: "Quicksand";
  src: url("assets/font/two/Quicksand-Medium.eot");
  src: url("assets/font/two/Quicksand-Medium.eot?#iefix") format("embedded-opentype"),
    url("assets/font/two/Quicksand-Medium.woff2") format("woff2"),
    url("assets/font/two/Quicksand-Medium.woff") format("woff"),
    url("assets/font/two/Quicksand-Medium.ttf") format("ttf"),
    url("assets/font/two/Quicksand-Medium.svg#Quicksand-Medium") format("svg");
}
body {
  font-family: "Quicksand" !important;
}
body {
  background-color: #fff;
}

.container_class {
  overflow: hidden;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
  transform: translateX(100em);
}
.fade-enter-active,
.fade-leave-active {
  transition: all 0.6s ease;
}
#app {
  overflow: hidden;
  width: 100vw;
}
@import "../public/assets/css/style.css";
@import "../public/assets/css/slick-theme.css";
@import "../public/assets/css/slick-theme2.css";
@import "../public/assets/css/darktheme.css";
@import "../public/assets/css/lighttheme.css";
@import "../public/assets/css/custom.css";
@import "../public/assets/css/meanmenu.css";
@import "../public/assets/css/settings.css";
@import "../public/assets/css/activity.css";
@import "/public/assets/scss/carousel.scss";
@import "/public/assets/scss/custom.scss";
</style>
